<script>
export default {
    name: 'IlluEleves',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-eleves"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M32 28.5c-4.31 0-8.294 1.398-11.522 3.766A19.542 19.542 0 0013.441 42a19.536 19.536 0 007.037 9.735A19.412 19.412 0 0032 55.5c4.31 0 8.294-1.398 11.522-3.767A19.54 19.54 0 0050.56 42a19.54 19.54 0 00-7.037-9.734A19.412 19.412 0 0032 28.5zm-14.5-2c-2.09 0-4.021.681-5.586 1.834A9.518 9.518 0 008.525 33a9.501 9.501 0 002.853 4.239l.456-.66c2.486-3.614 4.932-7.133 9.627-9.207A9.378 9.378 0 0017.5 26.5zm29 0a9.378 9.378 0 00-3.959.87c5.256 2.205 8.097 6.022 10.305 9.672A9.507 9.507 0 0055.475 33a9.518 9.518 0 00-3.389-4.666A9.384 9.384 0 0046.5 26.5zM32 8.5a8.473 8.473 0 00-6.01 2.49A8.473 8.473 0 0023.5 17c0 2.347.951 4.472 2.49 6.01A8.473 8.473 0 0032 25.5a8.473 8.473 0 006.01-2.49A8.473 8.473 0 0040.5 17a8.473 8.473 0 00-2.49-6.01A8.473 8.473 0 0032 8.5zm14.5 8c-.961 0-1.832.392-2.462 1.024A3.498 3.498 0 0043.018 20c0 .967.39 1.842 1.02 2.476.63.632 1.5 1.024 2.462 1.024.961 0 1.832-.392 2.462-1.024A3.498 3.498 0 0049.982 20c0-.967-.39-1.842-1.02-2.476A3.463 3.463 0 0046.5 16.5zm-29 0c-.961 0-1.832.392-2.462 1.024A3.498 3.498 0 0014.018 20c0 .967.39 1.842 1.02 2.476.63.632 1.5 1.024 2.462 1.024.961 0 1.832-.392 2.462-1.024A3.498 3.498 0 0020.982 20c0-.967-.39-1.842-1.02-2.476A3.463 3.463 0 0017.5 16.5z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <path
                d="M36 19c-.333 2.333-1.667 3.5-4 3.5s-3.667-1.167-4-3.5h8zm-17 2c-.333.667-.833 1-1.5 1s-1.167-.333-1.5-1h3zm29 0c-.333.667-.833 1-1.5 1s-1.167-.333-1.5-1h3z"
                :fill="primaryColor"
                class="primary-color"
            />
        </g>
    </svg>
</template>
